import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"padding-top":"10px"}
}
const _hoisted_3 = {
  key: 0,
  class: "ant-timeline ss-registro-atividade-recurso"
}
const _hoisted_4 = {
  key: 0,
  class: "ant-timeline-item-tail"
}
const _hoisted_5 = {
  key: 1,
  class: "ant-timeline-item-head ant-timeline-item-head-green"
}
const _hoisted_6 = {
  key: 2,
  class: "ant-timeline-item-head ant-timeline-item-head-blue"
}
const _hoisted_7 = { class: "ant-timeline-item-content ss-registro-atividade-recurso-detalhes" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Data:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Usuário:", -1)
const _hoisted_10 = {
  class: "ant-timeline-item-content ss-registro-atividade-recurso-detalhes",
  style: {"white-space":"pre"}
}
const _hoisted_11 = {
  key: 3,
  class: "ss-registro-atividade-recurso-linha"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.props.registros.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.registros, (registro, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "ant-timeline-item"
              }, [
                (index+1 !== _ctx.props.registros.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                  : _createCommentVNode("", true),
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6)),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(registro.dataHora)) + " ", 1),
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(registro.codigoUsuario) + " - " + _toDisplayString(registro.nomeUsuario), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(registro.detalhe), 1),
                (index+1 !== _ctx.props.registros.length)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
            key: 1,
            mensagem: "Nenhum histórico encontrado."
          }))
    ])
  ]))
}